import React, { useState, useRef, useMemo } from 'react';
import { Badge, OverlayTrigger, Tooltip } from 'react-bootstrap';

export const SubmittedByCell = (rowProps) => {
   const createdData = rowProps.data?.created;
   const userName = createdData?.user?.name;
   
    return (
       <div>
            {userName ? userName : "No User Found"}
       </div>
    )
}

// Add this to force AgGrid to recreate the component instead of reusing it
SubmittedByCell.refresh = () => false;